<div class="navblock hidden-print">
    <button (click)="openCreateModal()" class="btnadd">{{'Add notification'|translate}}</button>

    <app-group-filter #groupFilter></app-group-filter>

    <div class="inputgroup">
        <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
               (input)="onTermChange($event)" />
    </div>
</div>

<div class="tablewrap">
    <div class="table">
        <table fixedcols="[0, 6]" id="exporttable">
            <tr>
                <th class="hidden-print">
                    <switch-all-checkbox [items]="objects | groupFilter : filter" />
                </th>
                <th>{{'Name' | translate}}</th>
                <th>{{'Type' | translate}}</th>
                <th>{{'Text template' | translate}}</th>
                <th>{{'Schedule' | translate}}</th>
                <th>{{'Objects' | translate}}</th>
                <th>{{'Geozones' | translate}}</th>
                <th>{{'Min. duration' | translate}}</th>
                <th class="hidden-print">&nbsp;</th>
            </tr>
            <tr *ngFor="let notification of objects | groupFilter : filter" [ngClass]="{'crossed': notification.Disabled}">
                <td class="hidden-print">
                    <input type="checkbox" [(ngModel)]="notification.IsChecked" />
                </td>
                <td>{{notification.Name}}</td>
                <td>
                    <span *ngIf="notification.EventType=='SPEED'">{{'Speed'|translate}}</span>
                    <span *ngIf="notification.EventType=='NO_DATA'">{{'No data'|translate}}</span>
                    <span *ngIf="notification.EventType=='OLDCURPOS'">{{'No connection to satellite'|translate}}</span>
                    <span *ngIf="notification.EventType=='PARK'">{{'Parking'|translate}}</span>

                    <span *ngIf="notification.EventType=='MOVE'">{{'Movement'|translate}}</span>
                    <span *ngIf="notification.EventType=='IDLING'">{{'Idling'|translate}}</span>
                    <span *ngIf="notification.EventType=='TREND_VALUE'">{{'Sensor value'|translate}}</span>
                    <span *ngIf="notification.EventType=='TREND_OUT_OF_SCALE'">{{'Sensor value out of scale'|translate}}</span>

                    <span *ngIf="notification.EventType=='EXITZONE'">{{'Leave geozone'|translate}}</span>
                    <span *ngIf="notification.EventType=='ENTERZONE'">{{'Enter in geozone'|translate}}</span>
                    <span *ngIf="notification.EventType=='PHOTO'">{{'Receiving photos'|translate}}</span>
                    <span *ngIf="notification.EventType=='FUEL_FILLING'">{{'Refueling'|translate}}</span>
                    <span *ngIf="notification.EventType=='FUEL_DRAIN'">{{'Fuel drain'|translate}}</span>
                </td>
                <td>{{notification.TextTemplate}}</td>
                <td>{{notification.Schedule}}</td>
                <td>{{notification.TrackerIds.length}}</td>
                <td>{{notification.InGeozones.length + notification.OutOfGeozones.length}}</td>
                <td>{{notification.MinDuration | time}}</td>
                <td class="hidden-print">
                    <button class="btn_img btn_dublicate" (click)="createDublicate(notification)" title="{{'Duplicate'|translate}}"></button>
                    <button class="btn_img btn_edit" (click)="openEditModal(notification)" data-toggle="tooltip" data-placement="top" title="{{'Edit'|translate}}"></button>
                    <button class="btn_img btn_trush" (click)="deleteObject(notification.Id)" title="{{'Delete'|translate}}"></button>
                </td>
            </tr>
        </table>
    </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="objects | groupFilter : filter"></app-footer-component>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
